import { useEffect, useState } from 'react';
import { Outlet, useParams, Navigate, useLocation } from 'react-router';
import i18n from '@/i18n';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/i18n';
import Layout from '@/components/Layout/Layout';
import Loading from '@/components/Loading/Loading';

export default function LangGuard() {
    const { lang } = useParams();
    const location = useLocation();
    const [ready, setReady] = useState(false);

    const isValidLang = lang && SUPPORTED_LANGUAGES.includes(lang);

    useEffect(() => {
        if (!isValidLang) return;

        const setLanguage = async () => {
            if (i18n.language !== lang) {
                await i18n.changeLanguage(lang);
            }
            setReady(true);
        };
        setReady(false);
        setLanguage();
    }, [lang, isValidLang, location.pathname]);

    if (!isValidLang) {
        return <Navigate to={"/" + DEFAULT_LANGUAGE + location.pathname} replace />;
    }

    if (!ready) {
        return <Layout><Loading /></Layout>;
    }

    return <Outlet />;
}
